import React from "react";
import { DayTimeParam } from "../../../messages/PatientTasks";
import { globalize } from "../../../translate";
import { formatTimes } from "../../../utils/dateUtils";
import { AppList, AppListItem } from "../../Generic/AppList";

interface Props {
  dayTimeParams: DayTimeParam[];
}

const DayTimeParamList = (props: Props) => {
  return (
    <AppList density="densed">
      {props.dayTimeParams.map((dayTimeParam) => (
        <AppListItem
          key={dayTimeParam.dayOfWeek.name()}
          title={globalize().formatDayOfWeek(dayTimeParam.dayOfWeek, false)}
          trailing={formatTimes({
            startAt: dayTimeParam.startTime,
            endAt: dayTimeParam.endTime,
          })}
          soft={true}
        />
      ))}
    </AppList>
  );
};

export default DayTimeParamList;
